/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react'
import { Button, ButtonProps, Tooltip } from '@mui/material'
import { Download as DownloadIcon } from '@mui/icons-material'
import { useGridApiContext, useGridSelector, gridRowsLookupSelector, GridToolbarExport } from '@mui/x-data-grid'
import { CsvExportHelper, IExportCsvOptionsModel } from './csv-export-helper'

export interface CustomExportButtonProps extends Omit<ButtonProps, 'onClick'> {
  csvOptions?: IExportCsvOptionsModel
  tooltip?: string
}

export const CustomExportButton: FC<CustomExportButtonProps> = (props) => {
  const { csvOptions, tooltip = 'Export CSV with UTF-8 encoding', children, ...buttonProps } = props

  const apiRef = useGridApiContext()
  const rowsLookup = useGridSelector(apiRef, gridRowsLookupSelector)

  const handleExport = () => {
    try {
      if (!csvOptions) {
        console.warn('No CSV export options provided')
        return
      }

      // Get all rows data from the grid
      const data = Object.values(rowsLookup)

      if (data.length === 0) {
        console.warn('No data available for export')
        return
      }

      const selectedRows = apiRef.current.getSelectedRows()
      if (selectedRows.size === 0) {
        // Export to CSV with UTF-8 BOM
        return CsvExportHelper.exportToCsv(data, csvOptions)
      }
      return CsvExportHelper.exportToCsv(Array.from(selectedRows.values()), csvOptions)
    } catch (error) {
      console.error('Export failed:', error)
    }
  }

  if (!csvOptions) return <GridToolbarExport />

  return (
    <Tooltip title={tooltip} arrow>
      <Button size='small' variant='text' startIcon={<DownloadIcon />} onClick={handleExport} {...buttonProps}>
        {children || 'Export'}
      </Button>
    </Tooltip>
  )
}
